'use strict';
import * as $j_app$002eapi$002e$002dIn$002dMaintenance$002dData from "./app.api.-In-Maintenance-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$$anon$95(evaluator$41) {
  this.Lapp_api_PharmacyAppUpdate$$anon$95__f_evaluator$17 = null;
  this.Lapp_api_PharmacyAppUpdate$$anon$95__f_evaluator$17 = evaluator$41;
}
export { $c_Lapp_api_PharmacyAppUpdate$$anon$95 as $c_Lapp_api_PharmacyAppUpdate$$anon$95 };
$c_Lapp_api_PharmacyAppUpdate$$anon$95.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$$anon$95.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$$anon$95;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$$anon$95() {
}
export { $h_Lapp_api_PharmacyAppUpdate$$anon$95 as $h_Lapp_api_PharmacyAppUpdate$$anon$95 };
$h_Lapp_api_PharmacyAppUpdate$$anon$95.prototype = $c_Lapp_api_PharmacyAppUpdate$$anon$95.prototype;
$c_Lapp_api_PharmacyAppUpdate$$anon$95.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_PharmacyAppUpdate$$anon$95.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_PharmacyAppUpdate$$anon$95__f_evaluator$17.apply__O();
  return ((v instanceof $j_app$002eapi$002e$002dIn$002dMaintenance$002dData.$c_Lapp_api_InMaintenanceData) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_PharmacyAppUpdate$$anon$95.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_PharmacyAppUpdate$$anon$95 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$$anon$95, "app.api.PharmacyAppUpdate$$anon$95", ({
  Lapp_api_PharmacyAppUpdate$$anon$95: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$$anon$95 as $d_Lapp_api_PharmacyAppUpdate$$anon$95 };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$$anon$95.js.map
